import { useRef } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { ChartContainer } from '../../../../../../common/chart/chartContainer'
import Bar from '../../../../../../common/chart/chartContainer/Bar'
import { Element } from '../../../../../../common/html/element'
import { Icon } from '../../../../../../common/html/icon'
import { Tooltip } from '../../../../../../common/tooltip'
import { getUnique } from '../../../../../../helpers/common'
import { formatVal } from '../../../../../../helpers/value'

const ChartLeft = ({ data, propsChart, isDynamicReport }) => {
  const chartId = useRef(getUnique())
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <div className="h100 flexColumn">
      <div className="fw600 dFlex">
        <Translate value={propsChart.title} />
        {!isDynamicReport && propsChart.tooltipContent && (
          <Tooltip
            elementName="span"
            tooltipContent={propsChart.tooltipContent}
          >
            <Icon
              className="icon-info-circle ml1"
              style={{ color: '#9C9C9C', marginTop: 2 }}
            />
          </Tooltip>
        )}
      </div>
      <ChartContainer
        chartId={chartId.current}
        data={data}
        width="100%"
        height="100%"
        margin={{ top: 21, bottom: 0, left: 0, right: 0 }}
        xAxis={[
          {
            dataKey: propsChart.xAxisKey,
            tickMargin: 3,
            height: 18,
            padding: { left: 5, right: 5 },
          },
        ]}
        yAxis={[
          {
            yAxisId: 'left',
            dataKeys: [propsChart.dataKey],
            isBarChart: true,
            hide: true,
          },
        ]}
        tooltip={{
          schema: {
            content: [
              {
                dataKey: propsChart.dataKey,
                label: propsChart.label,
                formatValue: (value) => formatVal(value * 100, locale) + '%',
              },
            ],
          },
        }}
      >
        <Bar
          yAxisId="left"
          dataKey={propsChart.dataKey}
          fill={propsChart.color}
          barSize={40}
          label={<CustomizedLabel color={propsChart.color} />}
        />
      </ChartContainer>
    </div>
  )
}

const CustomizedLabel = (props) => {
  const { x, y, value, width } = props

  return value ? (
    <g style={{ pointerEvents: 'none' }}>
      <foreignObject x={x + 2} y={y - 20} height={16} width={width}>
        <Element
          style={{
            height: '24px',
            width: '31px',
            fontSize: 10,
            textAlign: 'center',
          }}
        >
          {formatVal(value * 100, undefined, undefined)}%
        </Element>
      </foreignObject>
    </g>
  ) : (
    <></>
  )
}

export default ChartLeft
